import React from 'react';
import { JobsitesWidget } from 'containers/jobsites/jobsitesWidget';
import { JobsitesTabProps } from 'containers/jobsites/types';

export function JobsitesTab(props: JobsitesTabProps): React.ReactElement {
  return <JobsitesWidget {...props} />;
}
